// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "toastr/build/toastr.min.css";

import App from "./App";
import { LoadingProvider } from "./contexts/LoadingContext";
import AuthProvider from "./contexts/AuthContext"; // Правильный импорт
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode>
    <AuthProvider>
      <LoadingProvider>
        <App />
      </LoadingProvider>
    </AuthProvider>
  // </React.StrictMode>
);

reportWebVitals();
